// Single source of truth for demo metal rates (AED per gram).
// Every surface that displays a price (nav ticker, live rates section,
// gold calculator) must import from here so the numbers never disagree.

export const GOLD_RATE_AED_PER_GRAM = 412.8;
export const GOLD_SELL_SPREAD = 3.2;

export const SILVER_RATE_AED_PER_GRAM = 4.85;
export const SILVER_SELL_SPREAD = 0.15;

// ─── Quarterly price history (performance section) ───────────────────────────
// Spot price in USD per troy ounce at each quarter close, oldest first,
// running from Q3 2016 through the current quarter (Q3 2026).
//
// These are only ever read as ratios against the final entry, then multiplied
// by the AED rates above — so the chart and the live rates can never disagree.

// Absolute quarter number of the first entry: year * 4 + quarterIndex (0 = Q1).
export const HISTORY_START_QUARTER = 2016 * 4 + 2;

export const GOLD_HISTORY_USD_PER_OZ = [
  1316, 1152, // 2016
  1249, 1242, 1283, 1303, // 2017
  1325, 1253, 1191, 1282, // 2018
  1292, 1409, 1472, 1517, // 2019
  1577, 1781, 1886, 1898, // 2020
  1707, 1770, 1757, 1829, // 2021
  1937, 1807, 1661, 1824, // 2022
  1969, 1919, 1849, 2063, // 2023
  2230, 2327, 2635, 2625, // 2024
  2870, 2950, 3050, 3150, // 2025
  3260, 3390, 3500, // 2026
];

export const SILVER_HISTORY_USD_PER_OZ = [
  19.2, 15.9, // 2016
  18.2, 16.6, 16.7, 17.0, // 2017
  16.3, 16.1, 14.6, 15.5, // 2018
  15.1, 15.2, 17.5, 17.9, // 2019
  14.0, 18.2, 23.2, 26.4, // 2020
  24.4, 26.2, 22.0, 23.3, // 2021
  24.8, 20.3, 19.0, 24.0, // 2022
  24.1, 22.8, 22.2, 23.8, // 2023
  24.9, 29.2, 31.2, 28.9, // 2024
  33.0, 34.0, 34.6, 36.2, // 2025
  38.4, 39.8, 41.1, // 2026
];
